<template>
  <div style="display: inline-block">
    <v-dialog v-model="showModal" persistent max-width="600">
      <template #activator="{ on }">
        <a
          href="javascript:void(0);"
          :style="{ 'font-size': size }"
          style="text-decoration: none"
          v-on="on"
        >
          <slot name="icon"></slot>
          <slot name="link"></slot>
        </a>
      </template>
      <v-card>
        <v-container>
          <div style="float: right">
            <v-btn fab small flat color="primary" @click="showModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <slot name="body"></slot>
          <div class="text-center" style="padding: 10px 0">
            <v-btn color="primary" outline @click="showModal = false">{{
              $t('Close')
            }}</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      default: '1.3em'
    }
  },
  data: function () {
    return {
      showModal: false
    }
  },
  watch: {},
  mounted: function () {}
}
</script>

<style scoped></style>
